import React, { useState } from "react"
import classes from "./knowledgeReport.module.css"
import SquareCard from "../../../DigitalMe/Cards/SquareCard/SquareCard"
import { Doughnut } from "react-chartjs-2"
import { MIconButton, MPaper } from "../../../../UI"
import TrendingFlatIcon from "@material-ui/icons/TrendingFlat";
import { useDispatch } from "react-redux"
import { updateKnowledgeScore } from "../../../../store/actions/knowledge.action"

export const ScoreCard = ({ id, title, percentage, competencyCategory, modelType }) => {
    const [isHovered, setIsHovered] = useState(false);
    const dispatch = useDispatch();

    const mouseEnterHandler = () => {
        setIsHovered(true)
    };
    const mouseLeaveHandler = () => {
        setIsHovered(false)
    };

    const displayArrow = () => {
        if (modelType === "Topic") {
            return <></>
        }
        return (
            <MIconButton
                size="small"
                onClick={() => dispatch(updateKnowledgeScore(id))}
            >
                <span style={{ color: "#0074E4" }}>
                    <TrendingFlatIcon />
                </span>
            </MIconButton>
        )

    }


    return (
        <>
            <div className={classes.scoreCardContainer}>
                <MPaper
                    elevation={isHovered ? 8 : 1}
                    onMouseEnter={mouseEnterHandler}
                    onMouseLeave={mouseLeaveHandler}
                    className={classes.Card}
                >
                    <div className={classes.scoreCardContentContainer}>
                        {/* Header */}
                        <div className={classes.CardHeader}>
                            <p
                                className={" FontPoppins "}
                            >
                                {title}
                            </p>
                            {displayArrow()}
                        </div>

                        {/* Body */}
                        <div className={classes.CardBody}>
                            <div className={classes.wheel}>
                                <Doughnut
                                    height={230}
                                    data={{
                                        datasets: [
                                            {
                                                data: [
                                                    percentage,
                                                    100 - percentage,
                                                ],
                                                backgroundColor: [
                                                    "rgba(0, 116, 228, 1)",
                                                    "rgba(0, 116, 228, 0.25)",
                                                ],
                                                borderColor: "transparent",
                                            },
                                        ],
                                    }}
                                    options={{
                                        responsive: true,
                                        maintainAspectRatio: true,
                                        cutoutPercentage: 90,
                                        tooltips: { enabled: false },
                                        hover: { mode: null },
                                    }}
                                />
                            </div>
                            <div className={classes.scoreText}>
                                <label
                                    className={" FontPoppins TextMediumGrey"}
                                >
                                    {`${percentage}%`}
                                </label>
                                <p
                                    className={" FontPoppins TextMediumGrey"}
                                >
                                    {competencyCategory}
                                </p>
                            </div>
                        </div>
                    </div>
                </MPaper>
            </div>
        </>
    )


}